var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","float":"left"},style:({ backgroundColor: _vm.btn.backgroundColor, opacity: _vm.btn.opacity, borderRadius: _vm.btn.borderRadius+'px' })})}
var staticRenderFns = []

export { render, staticRenderFns }